import postStyles from "./post-styles.module.css";

const PostBody = ({ content }) => {
  return (
    <div className="mx-auto max-w-2xl">
      <div
        className={postStyles["post"]}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default PostBody;
